import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { StoreReportCustomFieldsMapped } from '../../models/job-report';

export class FieldMultipleChoiceDetail {
  options: string[];
}

@Component({
  selector: 'tn-field-multiple-choice',
  templateUrl: './field-multiple-choice.component.html',
  styleUrls: ['./field-multiple-choice.component.scss']
})

export class FieldMultipleChoiceComponent implements OnInit {

  @Input() field: StoreReportCustomFieldsMapped;
  @Input() isInput: boolean = false;

  @Output() onFieldUpdate: EventEmitter<StoreReportCustomFieldsMapped> = new EventEmitter<StoreReportCustomFieldsMapped>(null);

  detail: FieldMultipleChoiceDetail;
  selectedValue: string;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges() {
    this.detail = JSON.parse(this.field.definition.detail);
    this.selectedValue = this.field.answer.value;
  }

  getAnswerValue(): string {
    return this.selectedValue;
  }

  onChange() {
    this.field.answer.value = this.getAnswerValue();
    this.onFieldUpdate.emit(this.field);
  }

}
